module.exports = __webpack_public_path__ + "static/img/p-6.e4d266a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-6.png
// module id = pd/h
// module chunks = 0